export default {"src":"/_next/static/image/src/images/our-food/spinach.d653f59bca30d1decf0443fe12e647d8.svg","height":35,"width":62};